import { render, staticRenderFns } from "./courseList.vue?vue&type=template&id=70f833bb"
import script from "./courseList.vue?vue&type=script&lang=ts"
export * from "./courseList.vue?vue&type=script&lang=ts"
import style0 from "./courseList.vue?vue&type=style&index=0&id=70f833bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports